<div>
    <div class="accordion accordion-custom" id="accordionPrice">
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingPrice">
                <button
                    class="accordion-button fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsePrice"
                    aria-expanded="true"
                    aria-controls="collapsePrice">
                    PRICE
                </button>
            </h2>
            <div id="collapsePrice"
                class="accordion-collapse collapse show"
                aria-labelledby="headingPrice"
                data-bs-parent="#accordionPrice">
                <div class="header-block">
                    <div class="header-block__header">Price</div>
                </div>
                <div class="info-block__pc">
                    <div class="info-block__line--blue"></div>
                    <div class="info-block__main">
                        <div class="info-block__row--big">
                            <span class="info-block__row__header">Total tariff</span>
                            <span class="info-block__row__value">{{ bookingPrice?.totalPrice | currency }}</span>
                        </div>
                        <div class="info-block__row" *ngFor="let payment of bookingPrice?.payments">
                            <span class="info-block__row__header">{{ payment.key }}</span>
                            <span class="info-block__row__value">{{ payment.value }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="accordion accordion-custom mt-3" id="accordionCargo">
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingCargo">
                <button
                    class="accordion-button fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseCargo"
                    aria-expanded="true"
                    aria-controls="collapseCargo">
                    CARGO
                </button>
            </h2>
            <div
                id="collapseCargo"
                class="accordion-collapse collapse show"
                aria-labelledby="headingCargo"
                data-bs-parent="#accordionCargo">
                <div class="header-block mt-5">
                    <div class="header-block__header">Cargo</div>
                </div>
                <div class="info-block__pc">
                    <div class="info-block__line--gray"></div>
                    <div class="info-block__main">
                        <div class="info-block__row">
                            <span class="info-block__row__header">Transport Type:</span>
                            <span class="info-block__row__value info-block__row__value__state">
                                {{ transportType }}
                            </span>
                        </div>
                        <div class="info-block__column">
                            <span class="info-block__row__header">Cargo:</span>
                            <span
                                [className]="vehicleClassName">
                                {{ vehicles }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>